import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid } from '../../../../../components/ATS/Grid/Grid';
import { Layout } from '../../../../../queries/ats/layout/types';
import css from './section-grid.module.scss';

interface SectionGridProps {
  view: Layout.SectionView;
  data: Layout.SectionItem[];
  onScrollBottom?: () => void;
}

export function SectionGrid({ data, view, onScrollBottom }: SectionGridProps) {
  return (
    <Fragment>
      <Helmet>
        <title>{view.label}</title>
      </Helmet>
      <Grid className={css.grid} onScrollBottom={onScrollBottom} pattern={view.style.pattern} items={data} />
    </Fragment>
  );
}

interface SectionGridSkeletonProps {
  view: Layout.SectionView;
}

export function SectionGridSkeleton({ view }: SectionGridSkeletonProps) {
  return (
    <Fragment>
      <Helmet>
        <title>{view.label}</title>
      </Helmet>
      <Grid.Skeleton className={css.grid} pattern={view.style.pattern} />
    </Fragment>
  );
}

SectionGrid.Skeleton = SectionGridSkeleton;
